import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../../api";
import "./CateGoryCamps.css";
import Loader from "../../../common/Loader";

function CateGoryCamps() {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}core/category/`)
      .then((res) => res.json())
      .then((data) => {
        setImages(data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <Loader text="Loading camps..." />;
  }

  return (
    <div className="CampsCategory-main">
      {images.map((categoryImgCamps) => (
        <Link
          to={`/camps-list/${categoryImgCamps.id}`}
          className="containercampslist"
          key={categoryImgCamps.id}
        >
          <div className="front">
            <img src={categoryImgCamps.image} alt="cherry blossoms" />
            <p className="caption">{categoryImgCamps.name}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default CateGoryCamps;
